import Config from '../classes/Config';
import PlayGame from './PlayGame';
import GameButton from '../classes/GameButton';
import _ from 'lodash';
import { Dialog } from '@capacitor/dialog';

export default class CustomGame extends Phaser.Scene {
  constructor() {
    super({
      key: 'CustomGame'
    });
  }

  static privacyOptions = [
    { key: 'public', label: 'Public\n(Anyone can join)', portraitLabel: 'Public\n(Anyone)', file: 'on' },
    { key: 'friends', label: 'Friends Only\n(Friends & Invitees)', portraitLabel: 'Friends Only\n(Friends & Link)', file: 'on' },
    { key: 'private', label: 'Private\n(Invite / Code Only)', portraitLabel: 'Private\n(Code Only)', file: 'off' }
  ];

  panels = {};
  buttons = {};
  selectedPrivacy = 'friends';
  friendsTables = [];

  getWidth() {
    return this.cameras.main.width;
  }

  getHeight() {
    return this.cameras.main.height;
  }

  preload() {}

  async create() {
    this.scene.bringToTop();
    this.events.on('wake', () => {
      this.scene.bringToTop();
    });
    this.events.on('resume', () => {
      this.scene.bringToTop();
    });
    this.game.dnrConfig = new Config();
    this.selectedPrivacy = this.game.customGamePrivacy || 'friends';

    const background = new Phaser.GameObjects.Graphics(this);
    background.fillStyle(0x00a6b1, 1);
    background.fillRoundedRect(0, 0, this.getWidth(), this.getHeight(), 3);
    this.add.existing(background);

    background
      .setInteractive(
        new Phaser.Geom.Rectangle(0, 0, this.getWidth(), this.getHeight()),
        Phaser.Geom.Rectangle.Contains
      )
      .on('pointerdown', () => {});

    const isLandscape = window.showLandscape();
    const width = this.getWidth();
    const height = this.getHeight();

    let yChain = 45;
    if (isLandscape) {
      this.titleText = this.add.text(50, yChain + 10, 'Custom Game & Friends Tables', {
        font: '44px Arial Black',
        color: '#ffffff'
      });
      this.titleText.setShadow(3, 3, '#000000', 3, true);

      this.buttons.close = new GameButton({
        scene: this,
        x: width - 70,
        y: yChain,
        w: 50,
        h: 50,
        depth: this.depth + 1,
        text: '✖',
        font: '40px Arial',
        radius: 20,
        borderWidth: 4,
        clickFunction: () => {
          this.closeScene();
        },
        clickFunctionData: {}
      });

      // Table Privacy selector
      this.createTable({
        scene: this,
        data: CustomGame.privacyOptions,
        key: 'table privacy',
        columns: 3,
        rows: 1,
        height: 250,
        textKey: 'label',
        valueKey: 'key',
        fileKey: null,
        loadCallback: this.privacyLoadCallback,
        clickCallback: this.privacyClickCallback,
        showSlider: false,
        width: width - 100,
        x: 50,
        y: 130,
        showTitle: true
      });

      // Action buttons row
      const btnY = 400;
      const btnW = Math.floor((width - 100 - 40) / 2);
      this.buttons.startCustom = new GameButton({
        scene: this,
        x: 50,
        y: btnY,
        w: btnW,
        h: 95,
        depth: this.depth + 1,
        text: 'Start Custom Table',
        font: '36px Arial',
        radius: 24,
        borderWidth: 5,
        clickFunction: async () => {
          const pg = this.scene.get('PlayGame');
          this.closeScene();
          if (pg) {
            await pg.startCustomOnlineGame(this.selectedPrivacy);
          }
        },
        clickFunctionData: {}
      });
      this.buttons.startCustom.select();

      this.buttons.joinByCode = new GameButton({
        scene: this,
        x: 50 + btnW + 40,
        y: btnY,
        w: btnW,
        h: 95,
        depth: this.depth + 1,
        text: 'Join by Table Code',
        font: '34px Arial',
        radius: 24,
        borderWidth: 4,
        clickFunction: async () => {
          const { value, cancelled } = await Dialog.prompt({
            title: 'Join Table by Code',
            message: 'Enter the Table Code (e.g. AVA-ABCD or ABCD):',
            inputText: ''
          });
          if (!cancelled && value && value.trim()) {
            const pg = this.scene.get('PlayGame');
            this.closeScene();
            if (pg) {
              await pg.joinCustomTableById(value.trim());
            }
          }
        },
        clickFunctionData: {}
      });
    } else {
      // Portrait mode: top title and close button
      this.titleText = this.add.text(35, 25, 'Custom Game', {
        font: '40px Arial Black',
        color: '#ffffff'
      });
      this.titleText.setShadow(3, 3, '#000000', 3, true);

      this.buttons.close = new GameButton({
        scene: this,
        x: width - 75,
        y: 20,
        w: 55,
        h: 55,
        depth: this.depth + 1,
        text: '✖',
        font: '40px Arial',
        radius: 20,
        borderWidth: 4,
        clickFunction: () => {
          this.closeScene();
        },
        clickFunctionData: {}
      });

      const margin = 30;
      const contentW = width - (margin * 2);

      // Table Privacy selector
      this.createTable({
        scene: this,
        data: CustomGame.privacyOptions,
        key: 'table privacy',
        columns: 3,
        rows: 1,
        height: 195,
        textKey: 'label',
        valueKey: 'key',
        fileKey: null,
        loadCallback: this.privacyLoadCallback,
        clickCallback: this.privacyClickCallback,
        showSlider: false,
        width: contentW,
        x: margin,
        y: 90,
        showTitle: true
      });

      // Action buttons stacked vertically
      const btnH = 75;
      this.buttons.startCustom = new GameButton({
        scene: this,
        x: margin,
        y: 305,
        w: contentW,
        h: btnH,
        depth: this.depth + 1,
        text: 'Start Custom Table',
        font: '32px Arial',
        radius: 18,
        borderWidth: 4,
        clickFunction: async () => {
          const pg = this.scene.get('PlayGame');
          this.closeScene();
          if (pg) {
            await pg.startCustomOnlineGame(this.selectedPrivacy);
          }
        },
        clickFunctionData: {}
      });
      this.buttons.startCustom.select();

      this.buttons.joinByCode = new GameButton({
        scene: this,
        x: margin,
        y: 395,
        w: contentW,
        h: btnH,
        depth: this.depth + 1,
        text: 'Join by Table Code',
        font: '30px Arial',
        radius: 18,
        borderWidth: 4,
        clickFunction: async () => {
          const { value, cancelled } = await Dialog.prompt({
            title: 'Join Table by Code',
            message: 'Enter the Table Code (e.g. AVA-ABCD or ABCD):',
            inputText: ''
          });
          if (!cancelled && value && value.trim()) {
            const pg = this.scene.get('PlayGame');
            this.closeScene();
            if (pg) {
              await pg.joinCustomTableById(value.trim());
            }
          }
        },
        clickFunctionData: {}
      });
    }

    this.friendsTablesContainer = this.add.container(0, 0);
    await this.loadFriendsTablesSection();
  }

  async loadFriendsTablesSection() {
    this.friendsTables = (await this.game.getFriendsOpenTables()) || [];
    if (this.friendsTablesPanel) {
      this.friendsTablesPanel.destroy();
      this.friendsTablesPanel = null;
    }
    this.friendsTablesContainer.removeAll(true);

    const isLandscape = window.showLandscape();
    const margin = isLandscape ? 50 : 30;
    const width = this.getWidth() - (margin * 2);
    const yPos = isLandscape ? 515 : 485;
    const hPos = Math.max(170, this.getHeight() - yPos - 30);

    if (this.friendsTables.length === 0) {
      const bg = this.add.graphics();
      bg.fillStyle(0xffffff, 0.95);
      bg.fillRoundedRect(margin, yPos, width, hPos, 12);
      this.friendsTablesContainer.add(bg);

      const txt = this.add.text(
        margin + width / 2,
        yPos + hPos / 2,
        'Friends\' Open Tables: None waiting right now.\nStart a Friends Only or Private table above and share the invite link!',
        {
          font: isLandscape ? '26px Arial' : '22px Arial',
          color: '#333333',
          align: 'center',
          wordWrap: { width: width - 40, useAdvancedWrap: true }
        }
      ).setOrigin(0.5);
      this.friendsTablesContainer.add(txt);
      return;
    }

    const tableData = this.friendsTables.map((t) => ({
      key: t.id,
      label: `${t.host_name}'s Table (${t.id})\n${t.players}/${t.max_players} Seated • ${t.privacy === 'friends' ? 'Friends Only' : 'Public'}`
    }));

    this.friendsTablesPanel = this.createTable({
      scene: this,
      data: tableData,
      key: 'friends open tables (tap to join)',
      columns: 1,
      rows: tableData.length,
      height: hPos,
      textKey: 'label',
      valueKey: 'key',
      fileKey: null,
      loadCallback: (_, label) => {
        label.getElement('background').setFillStyle(PlayGame.COLOR_GOLD);
      },
      clickCallback: async (child) => {
        if (child && child.name) {
          const pg = this.scene.get('PlayGame');
          this.closeScene();
          if (pg) {
            await pg.joinCustomTableById(child.name);
          }
        }
      },
      showSlider: true,
      width,
      x: 50,
      y: yPos,
      showTitle: true
    });
  }

  closeScene() {
    this.input.topOnly = true;
    this.scene.pause('CustomGame');
    this.scene.setVisible(false, 'CustomGame');
    this.scene.stop('CustomGame');
  }

  privacyLoadCallback(scene, label) {
    if (label.name === this.selectedPrivacy) {
      this.selectPrivacyChild(label);
    }
  }

  privacyClickCallback(child) {
    this.selectedPrivacy = child.name;
    this.game.customGamePrivacy = child.name;
    this.selectPrivacyChild(child);
  }

  selectPrivacyChild(child) {
    if (this.selectedPrivacyLabel && this.selectedPrivacyLabel.getElement('background')) {
      this.selectedPrivacyLabel.getElement('background').setFillStyle(0xe8eef2);
    }
    child.getElement('background').setFillStyle(PlayGame.COLOR_GOLD);
    this.selectedPrivacyLabel = child;
  }

  createIcon(scene, item, textKey, valueKey, fileKey, loadCallback, scaleIconsTo, showTextLabel, itemWidth) {
    const isLandscape = window.showLandscape();
    const bgColor = 0xe8eef2;
    const displayText = (!isLandscape && item.portraitLabel) ? item.portraitLabel : item[textKey];
    const textFont = isLandscape ? '24px Arial Black' : '15px Arial Black';
    const textObj = showTextLabel
      ? scene.add.text(0, 0, displayText, {
          font: textFont,
          color: '#000000',
          align: 'center',
          wordWrap: itemWidth ? { width: itemWidth - (isLandscape ? 16 : 8), useAdvancedWrap: true } : undefined
        })
      : null;

    const labelConfig = {
      background: scene.rexUI.add.roundRectangle(0, 0, itemWidth || 0, 0, 14, bgColor),
      orientation: 'y',
      icon: fileKey ? scene.add.sprite(0, 0, item[fileKey]).setScale(scaleIconsTo) : null,
      text: textObj,
      name: item[valueKey || textKey],
      space: isLandscape
        ? { left: 16, right: 16, top: 18, bottom: 18, icon: 6 }
        : { left: 4, right: 4, top: 12, bottom: 12, icon: 4 }
    };
    if (itemWidth) {
      labelConfig.width = itemWidth;
    }
    const label = scene.rexUI.add.label(labelConfig);
    label.enableLayoutWarn(false);
    loadCallback && loadCallback.call(this, scene, label);
    return label;
  }

  createTable({
    scene,
    data,
    key,
    rows = 1,
    columns = null,
    textKey,
    valueKey,
    fileKey,
    showTextLabel = true,
    loadCallback,
    scrollMode = 0,
    clickCallback,
    width = 1,
    height = 260,
    showTitle = false,
    showSlider = true,
    x = 50,
    y = 140,
    scaleIconsTo = 0.45
  }) {
    const isLandscape = window.showLandscape();
    const actualColumns = columns || (rows === 1 ? data.length : 1);
    const actualRows = rows || Math.ceil(data.length / actualColumns);

    const panelPaddingH = isLandscape ? 12 : 8;
    const panelPaddingV = isLandscape ? 10 : 8;
    const sizerPaddingH = isLandscape ? 12 : 8;
    const sizerPaddingV = isLandscape ? 12 : 8;

    const sliderWidth = showSlider ? (isLandscape ? 20 : 16) : 0;
    const sliderGap = showSlider ? (isLandscape ? 10 : 6) : 0;
    const panelWidth = Math.max(1, width - (panelPaddingH * 2) - sliderWidth - sliderGap);
    const availableGridWidth = Math.max(1, panelWidth - (sizerPaddingH * 2));

    const colGap = isLandscape ? 16 : 8;
    const rowGap = isLandscape ? 15 : 10;
    const itemWidth = actualColumns > 1
      ? Math.floor((availableGridWidth - (colGap * (actualColumns - 1))) / actualColumns)
      : availableGridWidth;

    const scrollablePanel = scene.rexUI.add
      .scrollablePanel({
        x,
        y,
        name: key,
        width,
        height,
        scrollMode,
        background: scene.rexUI.add.roundRectangle(0, 0, 2, 2, 10, 0xffffff),
        panel: {
          child: scene.rexUI.add
            .fixWidthSizer({
              space: { left: sizerPaddingH, right: sizerPaddingH, top: sizerPaddingV, bottom: 8, item: 8, line: 8 }
            })
            .enableLayoutWarn(false),
          width: panelWidth,
          mask: { mask: true, padding: { right: -5 }, updateMode: 'everyTick' }
        },
        scroller: {},
        slider: showSlider
          ? {
              track: scene.rexUI.add.roundRectangle(0, 0, sliderWidth, 10, 10, PlayGame.COLOR_LIGHT),
              thumb: scene.rexUI.add.roundRectangle(0, 0, 0, 0, sliderWidth, PlayGame.COLOR_GOLD)
            }
          : {},
        space: { left: panelPaddingH, right: panelPaddingH, top: panelPaddingV, bottom: panelPaddingV, panel: sliderGap }
      })
      .enableLayoutWarn(false)
      .setOrigin(0)
      .layout();

    this.panels[key] = scrollablePanel;

    const table = scene.rexUI.add
      .gridSizer({
        column: actualColumns,
        row: actualRows,
        columnProportions: 1,
        rowProportions: 1,
        space: { column: colGap, row: rowGap },
        name: key
      })
      .enableLayoutWarn(false);

    table.setChildrenInteractive().on('child.click', clickCallback, this);
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const r = actualRows === 1 ? 0 : Math.floor(i / actualColumns);
      const c = actualRows === 1 ? i : (i % actualColumns);
      table.add(
        this.createIcon(scene, item, textKey, valueKey, fileKey, loadCallback, scaleIconsTo, showTextLabel, itemWidth),
        c,
        r,
        'center',
        0,
        true
      );
    }

    if (showTitle) {
      const capKey = key.charAt(0).toUpperCase() + key.slice(1);
      const title = scene.rexUI.add.label({
        width: availableGridWidth,
        orientation: 'x',
        text: scene.add.text(0, 0, capKey, {
          font: isLandscape ? '30px Arial Black' : '22px Arial Black',
          color: '#000000'
        })
      });
      scrollablePanel.getElement('panel').add(title, 0, 'left', 0, true);
    }

    scrollablePanel.getElement('panel').add(table, 1, 'left', 0, true);
    scrollablePanel.layout();
    return scrollablePanel;
  }
}
